export const isValidDate = (value) => {
   const [mm, dd, yyyy] = value.split('-').map(Number);
   if (!mm || !dd || !yyyy) return false;

   const date = new Date(yyyy, mm - 1, dd);
   return (
     date.getFullYear() === yyyy &&
     date.getMonth() === mm - 1 &&
     date.getDate() === dd
   );
}

export const TestValidate = () => {
    console.log("test validation reached")
}
export const getValidationMessage = (ref) => {
  const inputComponent = ref?.current?.inputRef?.current;
  const nativeInput =
    ref?.current?.nativeInputRef?.current || inputComponent?.input || inputComponent;

  if (!nativeInput) return "";

  const message = nativeInput.validationMessage;
  const isInvalid = nativeInput.validity && !nativeInput.validity.valid;

  return isInvalid && message ? message : "";
};

export const updateValidationSummary = (setValidationSummaryMessages,  validationSummaryMessages,  validationSummaryMessage, pageId, fieldId, isFieldValid) => {
  const messages = JSON.parse(JSON.stringify(validationSummaryMessages));
  if (!messages[pageId]) {
    messages[pageId] = {};
  } 

  const existingMessage = messages[pageId][fieldId];
  
  if(isFieldValid && existingMessage) {
    // Remove message if field is valid{
    delete messages[pageId][fieldId];
  }
  
  if (!isFieldValid) {
    // Add or update message if field is invalid
    messages[pageId][fieldId] = validationSummaryMessage;
  }

  setValidationSummaryMessages(messages);

}